<template>
    <div class="stepsdemo-content">
        <Card>
            <template v-slot:title>
                Riepilogo
            </template>
            <template v-slot:subtitle>
                I dati che hai inserito
            </template>
            <template v-slot:content>
                <div class="grid">
                    <div class="col-12 md:col-6"><b>Pod:</b>{{formData.pod}}</div> 
                    <div class="col-12 md:col-6" v-if="formData.cc"><b>C. Commerciale attuale:</b>{{formData.cc}}</div> 
                    <div class="col-12 md:col-6"><b>Cliente:</b>{{(formData.client.nome == null || formData.client.nome == '' ) ? formData.client.ragsoc : formData.client.nome+" "+formData.client.cognome }}</div>
                    <div class="col-12 md:col-6" v-if="formData.client.cod_fiscale"><b>Cf attivazione:</b>{{formData.client.cod_fiscale}}</div>
                    <div class="col-12 md:col-6" v-if="formData.client.partita_iva"><b>Piva attivazione:</b>{{formData.client.partita_iva}}</div>
                    <div class="col-12 md:col-6"><b>Contratto associato:</b>{{formData.contratto.code}}</div> 
                    <div class="col-12 md:col-6"><b>Tipo Contratto:</b>{{formData.contratto.tipo_ctr}}</div> 
                    <div class="col-12 md:col-6"><b>Indirizzo:</b>{{formData.toponimo}} {{formData.address}}, {{formData.civico}}</div>
                    <div class="col-12 md:col-6"><b>Cap:</b>{{formData.cap}}</div>
                    <div class="col-12 md:col-6"><b>Sede:</b>{{formData.city}} -  ({{formData.district}})</div>
                    <div class="col-12 md:col-6"><b>Voltaggio:</b>{{formData.voltaggio}}</div>
                    <div class="col-12 md:col-6"><b>Potenza Disponibile:</b>{{formData.potenza_disp}}</div>
                    <div class="col-12 md:col-6"><b>Potenza Imponibile:</b>{{formData.potenza_imp}}</div>
                    <div class="col-12 md:col-6"><b>Consumo annuo:</b>{{formData.consumo_annuo}}</div>
                    <div class="col-12 md:col-6"><b>Distributore:</b>{{formData.distributore.name}}</div>
                    <div class="col-12 md:col-6"><b>Misuratore:</b>{{formData.misuratore.name}}</div>
                    <div class="col-12 md:col-6"><b>Uso:</b>{{formData.uso.name}}</div>
                    <div class="col-12 md:col-6"><b>Residente:</b>{{formData.residente.name}}</div>
                    <div class="col-12 md:col-6"><b>Tensione:</b>{{formData.tensione.name}}</div>
                    <div class="col-12 md:col-6"><b>Stato:</b>{{formData.stato.name}}</div>
                    <div class="col-12 md:col-6"><b>Stima:</b>{{formData.stima.name}}</div>
                    <div class="col-12 md:col-6"><b>Cf attivazione:</b>{{formData.cod_fiscale}}</div>
                    <div class="col-12 md:col-6"><b>P.iva attivazione:</b>{{formData.partita_iva}}</div>
                    <div class="col-12 md:col-6"><b>Note:</b>{{formData.note}}</div>
                    <div class="col-12 md:col-6">
                      <b>File caricati:</b>
                        <div v-for="(file, index) in formData.files" :key="index">
                          <i class="pi pi-file" style="font-size: 1rem mr-1"></i>
                          {{file.name}}
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <div class="grid justify-content-between">
                    <Button label="" @click="prevPage()" icon="pi pi-angle-left" iconPos="right" />
                    <i></i>
                    <Button  label="Salva" :disabled="isDisable" @click="complete()" icon="pi pi-check" iconPos="right" class="p-button-success"/>  
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import {ref, getCurrentInstance} from 'vue'
import Service from '@/services/ask-pratiche/pratiche-wizard'
import Card from 'primevue/card';
import Button from 'primevue/button';


export default {
    components: {
        Card,
        Button,
    },
    props: {
        formData: Object
    },
    setup (props, {emit}) {

  
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      const service = new Service(self.$eventBus)
      const isDisable = ref(false);
  
      const prevPage = () => {
          emit('prev-page', {pageIndex: 6});
      }

      const complete = async () => {
        emit("activeLoader", true)
        let fd = new FormData();
        for (let i = 0 ; i < props.formData.files.length ; i++) {
            fd.append('files[]', props.formData.files[i]); 
        }              
        fd.append('data', JSON.stringify(props.formData));
        
        service.saveFornituraEnergy(fd).then((res) => {
          isDisable.value = true
          if (!res) {
            setTimeout(function() {
              emit('complete');
            }, 
            1800); 
          }
        }).finally(()=>{
          emit("activeLoader", false)
          isDisable.value = false
        })
      }

        return {prevPage, complete, isDisable}
    },
    
}
</script>
